import type React from 'react';

import type { EmptyProps } from '@change-corgi/core/types';

/**
 * EXPERIMENT: psf_promote_or_share_facebook_post_sheet_experiment. A temporary plain outline shield for
 * the review note, as the prototype draws it. DS v15 has no shield icon, and design
 * approved a temporary icon for the experiment. Replace it with a DS icon if the sheet productizes.
 * Decorative: the note's text says what it means.
 */
export const ShieldIcon: React.FC<EmptyProps> = () => (
	<svg
		aria-hidden="true"
		focusable="false"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		className="size-4 shrink-0"
		data-testid="facebook-post-sheet-review-note-icon"
	>
		<path d="M12 3 19 6v5c0 4.5-3 8.2-7 10-4-1.8-7-5.5-7-10V6z" />
	</svg>
);
